import { logLevel } from './logLevel';

export const loggerConfig = {
    // DILoggerOptions does not support `trace` or `fatal`
    level: logLevel === 'trace' ? 'debug' : logLevel === 'fatal' ? 'off' : logLevel,
    disableRoutesSummary: process.env.NODE_ENV === 'development',
    ignoreUrlPatterns: process.env.NODE_ENV === 'development' ? ['/status'] : undefined,
};
